import queryString from 'query-string';

import { setData as markSsrAsRequested, fetchBooksPerSubscriptionInfo } from 'rebook/apps/base/actions/SsrActions';
import { fetchDemoPromoCampaign, fetchActivePromoCampaign } from 'rebook/apps/advert/actions/PromoCampaignActions';
import { fetchCurrentUser } from 'rebook/apps/users/actions/UserActions';
import { fetchPrices } from 'rebook/apps/payments/actions/PaymentsActions';


// eslint-disable-next-line import/prefer-default-export
export function fetchInitialData(location) {
  // fetch required global context for the app
  return async(dispatch, getState) => {
    const query = location && location.search ? queryString.parse(location.search) : null;
    const demoPromoCampaignId = query ? query['_promo_campaign_demo'] : null;

    const { user, promoCampaign, payments, ssr } = getState();
    let promises = [];
    if (!ssr.isRequested) {
      if (!user) {
        promises.push(dispatch(fetchCurrentUser()));
      }
      if (demoPromoCampaignId) {
        promises.push(dispatch(fetchDemoPromoCampaign(demoPromoCampaignId)));
      }
      else if (!promoCampaign) {
        promises.push(dispatch(fetchActivePromoCampaign()));
      }

      if (!payments.prices) {
        promises.push(dispatch(fetchPrices()));
      }

      promises.push(dispatch(fetchBooksPerSubscriptionInfo()));

      if (promises.length > 0) {
        await Promise.all(promises);
      }

      dispatch(markSsrAsRequested({ isRequested: true }));
    }
  };
};
